module.exports = __webpack_public_path__ + "img/cai2.a1bdd706.png";